<template>
  <div class="select">
    <div class="select-mask" @click="hiden" v-show="visible"></div>
    <div class="select-value" @click="show">
      <input
        type="text"
        class="select-value-ipt"
        :class="{ placeholderColor: placeholderColor }"
        :value="iptValue"
        :placeholder="placeholder"
        readonly
      />
      <svg-icon
        class="icon"
        v-if="iconStyle === 'down'"
        name="ChevronDown"
      ></svg-icon>
      <svg-icon class="icon" v-else name="ChevronRight"></svg-icon>
    </div>
    <transition name="fade">
      <div class="select-cont" v-show="visible">
        <div class="select-head">
          <div class="select-head-item" @click="onTabChange('province')">
            <span>省份</span>
            <span :class="provinceData.nodeName ? '' : 'textSubtitleColor'">
              {{ provinceData.nodeName || "未选择" }}
            </span>
          </div>
          <div class="select-head-item" @click="onTabChange('city')">
            <span>城市</span>
            <span :class="cityData.nodeName ? '' : 'textSubtitleColor'">
              {{ cityData.nodeName || "未选择" }}
            </span>
          </div>
          <div class="icon-close" @click.stop="hiden"></div>
          <div class="head-slider" :class="showPro ? '' : 'city'"></div>
        </div>
        <div class="dividing-line"></div>
        <div class="select-body-scroller" v-show="showPro">
          <div class="select-body">
            <div
              class="select-body-item"
              @click="onClickPro(item)"
              v-for="(item, idx) in dataList"
              :key="idx"
            >
              {{ item.nodeName }}
            </div>
          </div>
        </div>
        <div class="select-body-scroller" v-show="!showPro">
          <div class="select-body">
            <div
              class="select-body-item"
              @click="onClickCity(item)"
              v-for="(item, idx) in cityList"
              :key="idx"
            >
              {{ item.nodeName }}
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { getToast } from "@/components/Popup";
import { getOrderTime, get4City } from "@api/testDrive";
import SvgIcon from "@components/Icon/index.vue";

export default {
  components: {
    SvgIcon,
  },
  props: {
    placeholder: {
      default: "请选择试驾地点",
    },
    isGet4City: {
      default: false,
    },
    iconStyle: {
      default: "down", // right | down
    },
    placeholderColor: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
      dataList: [], //省数据
      cityList: [], //城市列表
      provinceData: {
        nodeName: "",
        nodeCode: "",
      },
      cityData: {
        nodeName: "",
        nodeCode: "",
      },
      showPro: true,
    };
  },
  computed: {
    iptValue({ provinceData, cityData }) {
      if (provinceData.nodeName) {
        return `${provinceData.nodeName} ${cityData.nodeName}`;
      }
      return "";
    },
  },
  methods: {
    show() {
      this.visible = true;
      this.getData();
    },
    hiden() {
      this.visible = false;
    },
    visiblePro() {
      this.showPro = true;
    },
    hidenPro() {
      this.showPro = false;
    },
    getData() {
      if (this.isGet4City) {
        get4City().then((res) => {
          this.dataList = res.data;
        });
      } else {
        getOrderTime().then((res) => {
          this.dataList = res.data;
        });
      }
    },
    onClickPro(item) {
      const { children, nodeCode, nodeName } = item;
      this.cityList = [...children];
      this.provinceData = {
        nodeCode,
        nodeName,
      };
      this.emitData();
      this.hidenPro();
    },
    onClickCity(item) {
      const { nodeCode, nodeName } = item;
      this.cityData = {
        nodeCode,
        nodeName,
      };
      this.emitData();
      this.hiden();
    },
    emitData() {
      let data = {
        province: {
          ...this.provinceData,
        },
        city: {
          ...this.cityData,
        },
      };
      this.$emit("comfirm", data);
    },
    onTabChange(key) {
      switch (key) {
        case "province":
          this.cityData = {
            nodeCode: "",
            nodeName: "",
          };
          this.emitData();
          this.visiblePro();
          break;
        case "city":
          if (!this.provinceData.nodeName) {
            getToast().open({
              text: "请先选择省",
            });
            return;
          }
          // eslint-disable-next-line no-case-declarations
          let curPro = this.dataList.find(
            (i) => i.nodeCode == this.provinceData.nodeCode
          );
          this.onClickPro(curPro);
          break;
        default:
          break;
      }
    },
  },
  mounted() {
    this.currentTime = Math.floor(new Date().getTime() / 1000);
  },
};
</script>
<style lang="scss" scoped>
@import "@style/base/mixins/media";
@import "@style/base/mixins/scrollBar";
@import "@style/base/variables";
.select {
  width: 100%;
  position: relative;
  .select-value {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 50px;
    cursor: pointer;
    .select-value-ipt {
      border: none;
      outline: none;
      height: 100%;
      width: 100%;
      font-size: inherit;
      background: none;
      cursor: pointer;
    }
  }
  .icon {
    font-size: 20px;
  }

  .arrow-dow {
    height: 20px;
    width: 20px;
    background-position: center;
    background-size: cover;
    background-image: url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20211018135757594-yuyueshijia_btn_down@3x.png);
  }
  .arrow-right {
    height: 20px;
    width: 20px;
    background-position: center;
    background-size: cover;
    background-image: url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20230713114032985-icon_Chevron.png);
  }
  @at-root {
    .select-cont {
      position: absolute;
      top: 0;
      left: 0;
      background: #fff;
      width: 100%;
      box-shadow: $boxShadow;
      border-radius: 4px;
      z-index: 10;
      cursor: pointer;
    }
    .select-head {
      height: 64px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      @at-root {
        .icon-close {
          position: absolute;
          height: 30px;
          width: 30px;
          top: 50%;
          right: 5px;
          margin-top: -15px;
          background-size: cover;
          background-position: center;
          background-image: url(https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud%2FbackendUpload%2F20210611133718303-icon_close%403x.png);
        }
        .head-slider {
          position: absolute;
          height: 3px;
          width: 50%;
          left: 0;
          bottom: -3px;
          background: #131415;
          transition: left 200ms $easeOutCubic;
          &.city {
            left: 50%;
          }
        }
      }
    }
    .select-head-item {
      width: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      line-height: 22px;
      white-space: nowrap;
    }
    .dividing-line {
      height: 3px;
      background: #f6f7f8;
    }
    .select-body-scroller {
      height: 260px;
      padding: 10px 0;
      width: 100%;
      @include scollBarRest(5px);
    }
    .select-body {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }
    .select-body-item {
      height: 40px;
      text-align: center;
      width: 50%;
      white-space: nowrap;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      @include media(
        (
          $sm: (
            width: 100%,
          ),
        )
      );
    }
  }
  .textSubtitleColor {
    color: #747a86;
  }
}
.select-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}
.placeholderColor {
  &::placeholder {
    color: #ccc;
  }
}
// 动画
.fade-enter-active,
.fade-leave-active {
  transition: opacity 200ms $easeOutCubic;
}
.fade-enter,
.fade-enter-from,
.fade-leave-to {
  opacity: 0 !important;
}
</style>
